module.exports = __webpack_public_path__ + "img/chatu.0e1a0524.png";